import { render, staticRenderFns } from "./AgentAddNew.vue?vue&type=template&id=37a066f5&"
import script from "./AgentAddNew.vue?vue&type=script&lang=js&"
export * from "./AgentAddNew.vue?vue&type=script&lang=js&"
import style0 from "./AgentAddNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports